import { zodResolver } from '@hookform/resolvers/zod';
import {
  Button,
  Form,
  Flex,
  FormRadioSelection,
  DialogActions,
  DialogContent,
  Divider,
} from '@shared/components';
import { useForm, FormProvider, type SubmitHandler } from 'react-hook-form';

import {
  ExportSingleQuestionFormat,
  QuestionExportFileTemplate,
  QUESTION_EXPORT_FILE_TYPE_OPTIONS,
  QUESTION_EXPORT_FILE_TEMPLATE_OPTIONS,
} from '../../constants';

import {
  QuestionExportFormSchema,
  type QuestionExportFormInput,
} from './question-export-form-schema';

interface QuestionExportFormProps {
  onClose: () => void;
  onSubmit: SubmitHandler<QuestionExportFormInput>;
}

export default function QuestionExportForm(props: Readonly<QuestionExportFormProps>) {
  const { onClose, onSubmit } = props;

  const formContext = useForm<QuestionExportFormInput>({
    defaultValues: {
      fileType: ExportSingleQuestionFormat.Pdf,
      template: QuestionExportFileTemplate.QUESTION_WITH_CHOICES,
    },
    resolver: zodResolver(QuestionExportFormSchema),
  });

  const { isSubmitting } = formContext.formState;

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={formContext.handleSubmit(onSubmit)}>
        <DialogContent sx={{ py: (theme) => theme.spacing(4) }}>
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
            <FormRadioSelection
              name='fileType'
              disabled={isSubmitting}
              options={QUESTION_EXPORT_FILE_TYPE_OPTIONS}
              label='ประเภทไฟล์'
              row
            />
            <FormRadioSelection
              name='template'
              disabled={isSubmitting}
              options={QUESTION_EXPORT_FILE_TEMPLATE_OPTIONS}
              label='รายละเอียด'
              row
            />
          </Flex>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            color='secondary'
            variant='outlined'
            size='large'
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button type='submit' size='large' loading={isSubmitting}>
            Export
          </Button>
        </DialogActions>
      </Form>
    </FormProvider>
  );
}
